import { hasPortlet } from '../util/findPortlets.js';

if (
  hasPortlet('sv-sharepointfile-portlet') ||
  hasPortlet('sv-sharepointsearchfilelist-portlet')
) {
  import(/* webpackChunkName: "sharepoint-portlet" */ './index.js');
  import(/* webpackChunkName: "sharepoint-i18n" */ './i18n.js'); //TODO: We don't want double imports, fix sharepoint-slim.js that doesn't import dynamic.
}
